import React from 'react';
import { Provider } from '../types';

interface Props {
  label: string;
  providers: Provider[];
  value: string;
  onChange: (value: string) => void;
}

export function ProviderSelector({ label, providers, value, onChange }: Props) {
  return (
    <div style={styles.container}>
      <label style={styles.label}>{label}</label>
      <div style={styles.options}>
        {providers.map((p) => (
          <button
            key={p.name}
            onClick={() => !p.disabled && onChange(p.name)}
            disabled={p.disabled}
            style={{
              ...styles.option,
              ...(value === p.name ? styles.selected : {}),
              ...(p.disabled ? styles.disabled : {}),
            }}
          >
            {p.label}
            {p.type === 'browser' && (
              <span style={styles.badge}>browser</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 1 },
  options: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  option: {
    padding: '6px 14px',
    borderRadius: 20,
    border: '1.5px solid #ddd',
    background: '#fff',
    cursor: 'pointer',
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    transition: 'all 0.15s',
  },
  selected: {
    borderColor: '#4f46e5',
    background: '#4f46e5',
    color: '#fff',
  },
  badge: {
    fontSize: 10,
    background: 'rgba(255,255,255,0.25)',
    padding: '1px 5px',
    borderRadius: 8,
  },
  disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
};
